module.exports = __webpack_public_path__ + "img/minip_app_image_handwritting.b42f4614.png";